import { render, staticRenderFns } from "./AssetLogoRenderer.vue?vue&type=template&id=444f7cf8&scoped=true&"
import script from "./AssetLogoRenderer.vue?vue&type=script&lang=ts&"
export * from "./AssetLogoRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f7cf8",
  null
  
)

export default component.exports